export const defaultBrand = {
  botType: '',
  fontColor: '#FFFFFF',
  messagingEndpoint: '',
  primaryColor: '#124459',
  title: 'Bot not found'
};
